let clickCounter = { time: 0, cnt: 0};


let dummy = document.createElement('div');
dummy.innerHTML = '<div hidden="" style="position: fixed; left: 0px; top: 0px; bottom: 0px; right: 0px; margin: 0px; border: 0px; color: rgb(204, 204, 204); overflow: scroll; background-color: rgb(51, 51, 51); font-size: 0.8rem; font-family: &quot;Lucida Console&quot;, monospace; z-index: 99;">'
              +    '<div class="status">'
              +       '<button class="clear">leeren</button>&nbsp;<button class="close">schließen</button>'
              +    '</div>'
              +    '<div class="container"></div>'
              + '</div>';

let logWindow = dummy.firstChild;
logWindow.classList.add('console');
document.body.appendChild(logWindow);

logWindow.querySelector('.clear').addEventListener('click', () => {
   logWindow.querySelector('.container').empty();
});


logWindow.querySelector('.close').addEventListener('click', () => {
   logWindow.setAttribute('hidden', '');
});

dummy = document.createElement('div');
dummy.innerHTML = '<div style="height: 20px; position: fixed; bottom: 0px; right: 0px; border: 1px solid black; padding: 0.3rem; background-color: rgb(255, 51, 51); z-index: 100; border-radius:50%">Fehlerkonsole</div>';

let logButton = dummy.firstChild;
document.body.appendChild(logButton);
logButton.classList.add('console-button');
logButton.innerHTML = "err";
logButton.setAttribute('hidden', '');

window.addEventListener('click', function(event) {

   let time = new Date().getTime();

   if (time - clickCounter.time < 1000) {
      clickCounter.cnt++;
   }
   else {
      clickCounter.time = time;
      clickCounter.cnt = 1;
   }

   if (clickCounter.cnt >= 5) {
      logButton.toggleAttribute('hidden');
   }



});

logButton.addEventListener('click', () => {
   if (logWindow.hasAttribute('hidden')) logWindow.removeAttribute('hidden');
   else logWindow.setAttribute('hidden', '');
});






class Logger {

   constructor() {

      let dummy = document.createElement('div');
      dummy.innerHTML = '<div><div style="border-bottom: 1px solid rgb(85, 85, 85); padding: 0.3rem;"><div class="log-main accordion" style="display: grid; grid-template-columns: auto auto; padding: 0px; color: rgb(204, 204, 204);"><div class="message" style="grid-column: 1 / auto; padding: 0px 0.5rem;">++ Cache 0.841</div><div class="reference" style="grid-column: 2 / auto; place-self: center right; padding: 0px 0.5rem;">:</div></div><div class="accordion-panel"><div class="outer"><div class="log-info" style="padding: 0px 0.5rem;">&nbsp;&nbsp;&nbsp;: in :<br></div></div></div></div></div>';

      this.template = dummy.firstChild;

   }

   getStack(error, stackBegin) {
      let stack = [];
      error.stack.split('\n').slice(stackBegin).forEach((item) => {
         let stackItem = {};
         let match = item.match(/at (.*) \(.*\/([^/:]+):(\d+):(\d+)\)/); // Chrome
         if (!match) match = item.match(/(.*)@.*\/([^/:]+):(\d+):(\d+)/); // Mozilla
         if (match) [stackItem.all, stackItem.func, stackItem.file, stackItem.line, stackItem.column] = match;
         else [stackItem.all, stackItem.func, stackItem.file, stackItem.line, stackItem.column] = ['','','','',''];
         stack.push(stackItem);
      });

      if (stack.length === 0) stack = [{ file: '?', line: '?' }];
      return stack;
   }

   createElement(text, reference, color) {

      let stack = this.getStack(new Error(), 3);

      if (reference === undefined) {
         reference = stack[0].file + ':' + stack[0].line;
      }

      let logNode = this.template.cloneNode(true);

      let messageNode = logNode.querySelector('.message');
      messageNode.setStyles({
         color: color
      });
      messageNode.innerHTML = text;

      let refNode = logNode.querySelector('.reference')

      refNode.innerHTML = reference;
      //logNode.querySelector('.log-main').accordion({});
      logWindow.querySelector('.container').prepend(logNode);

      let infoNode = logNode.querySelector('.log-info');

      for (let item of stack) {
         infoNode.innerHTML += '&nbsp;'.repeat(3) + (item.func + ': in ' + item.file + ':' + item.line).encodeHTML()+ '<br>';
      }
   }

   message(message, reference) {
      console.log(message);
      this.createElement(message, reference);
   }

   error(message, reference) {
      console.error(message);
      this.createElement(message, reference, '#f33');
   }

}

window.logger = new Logger();

window.onerror = function(message, source, lineno, colno, error) {
   window.logger.error(message, source.afterLast('/') + ': ' + lineno);
}
